import { Level } from 'src/core/types/Level';
import { StateCreator } from 'zustand';
import { ProfileUnits, Units } from 'src/core/types/Units';
import { CHPatientMappingDto } from 'src/core/types/ConsolidateHealth';

export interface SettingsSlice {
  newMessageCount: number;
  newAssessmentCount: number;
  newActionCount: number;
  units: Units;
  profileUnits: ProfileUnits;
  level: Level;
  enabledActionNotifications: boolean;
  enabledBiomarkerOfTheDayNotifications: boolean;
  enabledSleepStatNotifications: boolean;
  enabledActsOfKindnessNotifications: boolean;
  patientMapping: CHPatientMappingDto | undefined;
  setNewMessageCount: (newMessageCount: number) => void;
  setNewAssessmentCount: (newAssessmentCount: number) => void;
  setNewActionCount: (newActionCount: number) => void;
  setUnits: (units: Units) => void;
  setProfileUnits: (profileUnits: ProfileUnits) => void;
  setLevel: (level: Level) => void;
  setEnabledActionNotifications: (enabledActionNotifications: boolean) => void;
  setEnabledBiomarkerOfTheDayNotifications: (enabledBiomarkerOfTheDayNotifications: boolean) => void;
  setEnabledSleepStatNotifications: (enabledSleepStatNotifications: boolean) => void;
  setEnabledActsOfKindnessNotifications: (enabledActsOfKindnessNotifications: boolean) => void;
  setPatientMapping: (patientMapping: CHPatientMappingDto | undefined) => void;
}

export const createSettingsSlice: StateCreator<SettingsSlice, [], [], SettingsSlice> = (set) => ({
  newMessageCount: 0,
  newAssessmentCount: 0,
  newActionCount: 0,
  units: Units.Metric,
  profileUnits: ProfileUnits.Metric,
  level: Level.Lenient,
  enabledActionNotifications: false,
  enabledBiomarkerOfTheDayNotifications: false,
  enabledSleepStatNotifications: false,
  enabledActsOfKindnessNotifications: false,
  patientMapping: undefined,
  setNewMessageCount: (newMessageCount: number) => set(() => ({ newMessageCount })),
  setNewAssessmentCount: (newAssessmentCount: number) => set(() => ({ newAssessmentCount })),
  setNewActionCount: (newActionCount: number) => set(() => ({ newActionCount })),
  setUnits: (units: Units) => set(() => ({ units })),
  setProfileUnits: (profileUnits: ProfileUnits) => set(() => ({ profileUnits })),
  setLevel: (level: Level) => set(() => ({ level })),
  setEnabledActionNotifications: (enabledActionNotifications: boolean) => set(() => ({ enabledActionNotifications })),
  setEnabledBiomarkerOfTheDayNotifications: (enabledBiomarkerOfTheDayNotifications: boolean) =>
    set(() => ({ enabledBiomarkerOfTheDayNotifications })),
  setEnabledSleepStatNotifications: (enabledSleepStatNotifications: boolean) =>
    set(() => ({ enabledSleepStatNotifications })),
  setEnabledActsOfKindnessNotifications: (enabledActsOfKindnessNotifications: boolean) =>
    set(() => ({ enabledActsOfKindnessNotifications })),
  setPatientMapping: (patientMapping: CHPatientMappingDto | undefined) => set(() => ({ patientMapping }))
});
